var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"5px"}},[_c('RevenueChart',{ref:"rChart"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }